export default __webpack_public_path__ + "static/media/4271.5463ad39.png";